(() => {
  if (window.srCroV2Ready) return;
  window.srCroV2Ready = true;
  const init = () => {
    const hero = document.querySelector('[data-sr-cro]');
    if (!hero) return;
    const expire = () => {
      document.querySelectorAll('[data-sr-cro-offer]').forEach((element) => {
        const expiry = Number(element.dataset.expiry || 0) * 1000;
        if (expiry > Date.now()) return;
        element.querySelectorAll('[data-sr-cro-effective]').forEach((node) => { node.textContent = element.dataset.base; });
        element.querySelectorAll('[data-sr-cro-promotion]').forEach((node) => { node.hidden = true; });
        element.querySelectorAll('[data-sr-cro-fallback]').forEach((node) => { node.hidden = false; });
        element.querySelectorAll('[data-sr-cro-add]').forEach((node) => {
          if (!node.disabled) node.textContent = `${node.dataset.label} — ${element.dataset.base}`;
        });
      });
    };
    expire();
    const scheduleExpiry = () => {
    const nextExpiry = Math.min(...Array.from(document.querySelectorAll('[data-sr-cro-offer]')).map(x => Number(x.dataset.expiry || 0) * 1000).filter(x => x > Date.now()));
    if (Number.isFinite(nextExpiry)) window.setTimeout(() => { expire(); scheduleExpiry(); }, Math.min(nextExpiry - Date.now() + 100, 2147483647));
    };
    scheduleExpiry();
    hero.querySelectorAll("[data-sr-cro-open-support]").forEach(link => link.addEventListener("click", () => { const target = document.getElementById(link.getAttribute("href").slice(1)); if (target) target.open = true; }));
    const sticky = hero.querySelector('[data-sr-bph-sticky],[data-sr-sticky]');
    const mainButton = hero.querySelector('[data-sr-bph-main-add],[data-sr-add]');
    const quantity = hero.querySelector('input[name="quantity"]');
    if (!sticky || !mainButton) return;
    const quantityLabel = document.createElement('span');
    quantityLabel.className = 'sr-cro-sticky-quantity';
    quantityLabel.style.cssText = 'display:block;font-size:11px;font-weight:600;';
    const label = hero.dataset.srCroQuantityLabel || hero.querySelector('label[for*="Qty"],label[for*="Quantity"],.sr-pm-quantity__title')?.textContent.trim() || 'Quantity';
    const copy = sticky.querySelector('.sr-bph-sticky__copy,.sr-pm-sticky__copy,.sr-treats-sticky__copy');
    if (copy && quantity) copy.append(quantityLabel);
    const syncQuantity = () => { quantityLabel.textContent = `${label}: ${quantity?.value || 1}`; };
    quantity?.addEventListener('input',syncQuantity);
    quantity?.addEventListener('change',syncQuantity);
    hero.addEventListener('click',event => {
      if (event.target.closest('[data-sr-bph-qty-minus],[data-sr-bph-qty-plus],[data-sr-qty-minus],[data-sr-qty-plus]')) syncQuantity();
    });
    syncQuantity();
    let queued = false;
    const originalOffsets = new WeakMap();
    const position = () => {
      queued = false;
      const mobile = window.innerWidth <= 649;
      const google = document.getElementById('google-merchantwidget-iframe-wrapper');
      const rewards = document.getElementById('bon-loyalty-btn');
      const loyalty = document.getElementById('bon-iframe-container');
      const googleExpanded = google && google.getBoundingClientRect().height > 180;
      const loyaltyExpanded = loyalty && getComputedStyle(loyalty).visibility === 'visible' && getComputedStyle(loyalty).display !== 'none' && loyalty.getBoundingClientRect().height > 180;
      const reviewExpanded = document.querySelector('#AirReviews-Widget__Modal .AirReviews-Modal__Wrapper--Open-Modal');
      const modal = Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"]')).find(element => {
        const rect = element.getBoundingClientRect();
        return element.getAttribute('aria-hidden') !== 'true' && getComputedStyle(element).visibility !== 'hidden' && getComputedStyle(element).display !== 'none' && rect.width > 0 && rect.height > 0 && rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0;
      });
      const blocked = Boolean(googleExpanded || loyaltyExpanded || reviewExpanded || modal);
      if (blocked && mobile) {
        if (sticky.style.visibility !== 'hidden') sticky.style.setProperty('visibility','hidden','important');
        if (sticky.style.pointerEvents !== 'none') sticky.style.setProperty('pointer-events','none');
      } else {
        if (sticky.style.visibility) sticky.style.removeProperty('visibility');
        if (sticky.style.pointerEvents) sticky.style.removeProperty('pointer-events');
      }
      const showing = mobile && sticky.classList.contains('is-visible') && !blocked;
      const height = showing ? sticky.getBoundingClientRect().height : 0;
      const bottom = height + (showing ? 12 : 20);
      const setBottom = (element,value) => {
        if (element && element.style.getPropertyValue('bottom') !== `${value}px`) element.style.setProperty('bottom',`${value}px`,'important');
      };
      const offset = (element,property,value) => {
        if (!element) return;
        if (!originalOffsets.has(element)) originalOffsets.set(element,{});
        const original = originalOffsets.get(element);
        if (!original[property]) original[property] = {value:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)};
        if (element.style.getPropertyValue(property) !== value) element.style.setProperty(property,value,'important');
      };
      const restoreOffset = (element,property) => {
        const original = element && originalOffsets.get(element)?.[property];
        if (!original) return;
        if (original.value) {
          if (element.style.getPropertyValue(property) !== original.value || element.style.getPropertyPriority(property) !== original.priority) element.style.setProperty(property,original.value,original.priority);
        } else if (element.style.getPropertyValue(property)) element.style.removeProperty(property);
      };
      const lane = hero.querySelector('[data-sr-cro-widget-lane]');
      if (mobile && !showing && !blocked && lane) {
        const top = lane.getBoundingClientRect().top + window.scrollY;
        offset(rewards,'position','absolute');
        offset(rewards,'top',`${top + 8}px`);
        offset(rewards,'bottom','auto');
        offset(rewards,'left','8px');
        offset(google,'position','absolute');
        offset(google,'top',`${top + 88}px`);
        offset(google,'bottom','auto');
        offset(google,'right','0px');
      } else if (mobile) {
        offset(rewards,'position','fixed');
        offset(rewards,'top','auto');
        offset(rewards,'left','8px');
        setBottom(rewards,bottom);
        offset(google,'position','fixed');
        offset(google,'top','auto');
        if (googleExpanded) {
          restoreOffset(google,'right');
          setBottom(google,10 + (parseFloat(getComputedStyle(sticky).paddingBottom) || 0));
        } else {
          offset(google,'right','0px');
          setBottom(google,bottom + (rewards ? rewards.getBoundingClientRect().height + 12 : 0));
        }
      } else {
        restoreOffset(rewards,'position');
        restoreOffset(rewards,'top');
        restoreOffset(rewards,'left');
        restoreOffset(google,'position');
        restoreOffset(google,'top');
        restoreOffset(google,'right');
        setBottom(rewards,20);
        if (!googleExpanded) setBottom(google,30);
      }
      const reviewWrapper = document.querySelector('#AirReviews-FloatButtonWrapper .AirReviews-Widget__FloatButtonWrapper');
      const reviewButton = reviewWrapper?.querySelector('.AirReviews-Widget__FloatButton');
      if (mobile && reviewButton) {
        const rect = reviewButton.getBoundingClientRect();
        const controls = Array.from(hero.querySelectorAll('button,a,input')).map(x => x.getBoundingClientRect()).filter(x => x.width && x.height && x.bottom > 60 && x.top < window.innerHeight);
        const intersects = top => controls.some(x => rect.left < x.right && rect.right > x.left && top < x.bottom && top + rect.height > x.top);
        if (intersects(rect.top)) {
          const top = [70,window.innerHeight / 2 - rect.height / 2,window.innerHeight - bottom - rect.height - 12].find(x => x >= 60 && !intersects(x));
          if (top !== undefined) reviewWrapper.style.setProperty('top',`${parseFloat(getComputedStyle(reviewWrapper).top) + top - rect.top}px`,'important');
        }
      } else if (reviewWrapper?.style.top) reviewWrapper.style.removeProperty('top');
    };
    const schedule = () => { if (!queued) { queued = true; requestAnimationFrame(position); } };
    const watch = new MutationObserver(schedule);
    watch.observe(sticky,{attributes:true,attributeFilter:['class','style']});
    const watched = new WeakSet();
    const discoverWidgets = () => {
      ['google-merchantwidget-iframe-wrapper','bon-loyalty-btn','bon-iframe-container','AirReviews-Widget__Modal'].forEach(id => {
        const element = document.getElementById(id);
        if (element && !watched.has(element)) {
          watched.add(element);
          watch.observe(element,{attributes:true,subtree:id === 'AirReviews-Widget__Modal',attributeFilter:['style','class']});
        }
      });
    };
    const discover = new MutationObserver(() => {
      const google = document.getElementById('google-merchantwidget-iframe-wrapper');
      discoverWidgets();
      schedule();
      if (google && document.getElementById('bon-loyalty-btn')) discover.disconnect();
    });
    discover.observe(document.body,{childList:true,subtree:true});
    discoverWidgets();
    const portals = new MutationObserver(() => { discoverWidgets(); schedule(); });
    portals.observe(document.body,{childList:true});
    window.setTimeout(() => discover.disconnect(),15000);
    window.addEventListener('scroll',schedule,{passive:true});
    window.addEventListener('resize',schedule);
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(hero);
    document.addEventListener('toggle',schedule,true);
    document.addEventListener('click',schedule,true);
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',init,{once:true}); else init();
})();

